/**
 * Blue Tees Golf - Central Animation Controller (GSAP + ScrollTrigger)
 */
(() => {
  "use strict";

  const AppAnimation = {
    ctx: null,
    resizeObserver: null,

    init() {
      if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined")
        return;

      gsap.registerPlugin(ScrollTrigger);

      if (this.ctx) this.ctx.revert();

      this.ctx = gsap.context(() => {
        this.initFooterStickyAndStagger();
      });

      window.addEventListener("load", () => ScrollTrigger.refresh(), {
        once: true,
      });
    },

    initFooterStickyAndStagger() {
      const footer = document.querySelector(".site-footer.footer_animation");
      const mainContent = document.querySelector(".main_animation");
      const footerCols = gsap.utils.toArray(
        ".site-footer .footer-col-list > .footer-item"
      );

      if (!footer || !mainContent || !footerCols.length) return;

      // Sync footer height dynamically to mainContent margin
      const syncFooterHeight = () => {
        const h = footer.offsetHeight;
        if (h > 0) {
          mainContent.style.marginBottom = `${h}px`;
          ScrollTrigger.refresh();
        }
      };

      syncFooterHeight();

      // Observe dynamic height changes (reviews, lazy load, accordions)
      if (window.ResizeObserver) {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.resizeObserver = new ResizeObserver(() => syncFooterHeight());
        this.resizeObserver.observe(footer);
        this.resizeObserver.observe(mainContent);
      }

      // Initial hidden state
      gsap.set(footerCols, { opacity: 0, y: 25 });

      // Stagger reveal when revealed
      gsap.to(footerCols, {
        scrollTrigger: {
          trigger: mainContent,
          start: () => `bottom bottom-=${footer.offsetHeight * 0.85}`,
          end: "bottom bottom",
          invalidateOnRefresh: true,
        },
        opacity: 1,
        y: 0,
        duration: 0.8,
        stagger: 0.06,
        ease: "power2.out",
      });
    },

    destroy() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.ctx) this.ctx.revert();
    },
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => AppAnimation.init());
  } else {
    AppAnimation.init();
  }

  window.AppAnimation = AppAnimation;
})();
